import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  Skeleton,
  Typography,
} from "@mui/material";
import PropertySearch from "../../components/property-search";
import MapView from "../../components/MapView/index";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ImageModal } from "../../components/Images/image-modal";

const Home = () => {
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handlePropertySearch = (properties) => {
    setProperties(properties);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 4,
      }}
    >
      <PropertySearch
        onChange={handlePropertySearch}
        setIsLoadingProperties={setIsLoading}
      />

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 2,
            marginTop: 2,
          }}
        >
          {[...Array(3)].map((_, index) => (
            <Box height={300} key={index} width={345}>
              <Skeleton animation="wave" height={300} key={index} width={345} />
            </Box>
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 2,
            marginTop: 2,
          }}
        >
          {properties.map((property) => {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={`/property/${property.id}`}
                key={property.id}
              >
                <PropertyCard property={property} key={property.id} />
              </Link>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export const PropertyCard = ({
  additionalDetailsRenderer,
  backgroundColor="none",
  imageHeight = 194,
  property,
  redirectOnClick = true,
  showImageModalOnClick = false,
  showPrices = false,
  target,
  width = 345,
}) => {
  const [open, setOpen] = useState(false);
  const {
    city,
    estimatedValue = 0,
    latitude,
    longitude,
    photoUrl,
    photoUrls = [],
    photosAvailable = false,
    squareFeet = 0,
    state,
    streetAddress,
    zip,
  } = property;

  const Wrapper = redirectOnClick ? Link : Box;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card sx={{ backgroundColor, width }}>
      <Box height={imageHeight} overflow={"hidden"}>
        {photosAvailable ? (
          <CardMedia
            onClick={() => showImageModalOnClick && setOpen(true)}
            component="img"
            height={imageHeight}
            style={{
              minHeight: imageHeight,
              cursor: showImageModalOnClick ? "pointer" : "default",
            }}
            image={photoUrl || photoUrls[0]}
            alt={streetAddress}
          />
        ) : (
          <Box sx={{ backgroundColor: "#dcdfe4", height: "100%" }}>
            <MapView
              latitude={latitude}
              longitude={longitude}
              width={width}
              height={imageHeight}
            />
          </Box>
        )}
      </Box>
      <CardContent>
        <Wrapper
          style={{ textDecoration: "none" }}
          target={target}
          to={`/property/${property?.propertyId || property?.id}`}
          key={property.id}
        >
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontSize: 12 }}
          >
            {city}, {state}, {zip}
          </Typography>
          <Typography
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              fontWeight: 800,
              fontSize: showPrices ? 12 : 16,
            }}
          >
            {streetAddress || "-"}{" "}
          </Typography>
          {showPrices && (
            <Box sx={{ borderTopWidth: 1, mt: 1 }}>
              <Box>
                <Typography variant="caption" sx={{ color: "#000" }}>
                  Total cost:{" "}
                </Typography>
                <Typography variant="caption" fontWeight={800} ml={1}>
                  {estimatedValue ? `$${estimatedValue}` : "N/A"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="caption" sx={{ color: "#000" }}>
                  Cost per sqft:
                </Typography>
                <Typography variant="caption" fontWeight={800} ml={1}>
                  {squareFeet && estimatedValue
                    ? `$${Math.ceil(estimatedValue / squareFeet)}`
                    : "N/A"}
                </Typography>
              </Box>
              {additionalDetailsRenderer && additionalDetailsRenderer(property)}
            </Box>
          )}
        </Wrapper>
      </CardContent>
      {showImageModalOnClick && (
        <ImageModal
          open={open}
          onClose={handleClose}
          url={property?.photoUrl}
        />
      )}
    </Card>
  );
};

export default Home;
